export const findUnit = (marks) => {
  const mark = marks.find(m => m.value.includes(' '));
  return mark ? mark.value.split(' ')[1] : undefined;
}
